// @flow
/* eslint-disable no-unused-vars */
// Some API handles with constant values that can be used for short-circuited queries

import type { ApiId, JsonPath, ApiResponse, ApiHandle, ApiEndpoint } from './bind';

const createConstHandle = <T>(loading: boolean, value: ?T, error: ?string) => ({
  get: (dependencyId?: ApiId): ApiResponse<T> => ({
    loading: !!loading,
    data: value || null,
    error: error || null,
  }),
  select: (path: JsonPath) => '{:}',
});

export const NULL_HANDLE: ApiHandle<any> = createConstHandle(false, null, null);
export const LOADING_HANDLE: ApiHandle<any> = createConstHandle(true, null, null);
export const EMPTY_HANDLE: ApiHandle<Object> = createConstHandle(false, {}, null);
